import {
  PaymentMethodType,
  CreditCard,
  PaymentOnTerms,
  TransactionAccount,
  Maybe,
} from '@css-xp/graphtypes/src/generated-types-new';

export interface PaymentMethodProps {
  invoiceGroupId?: Maybe<string> | undefined;
  transactionAccount: Maybe<TransactionAccount>;
  paymentIssueStatusEnabled?: any;
  isIGFallbackDisabled?: boolean;
}

// this method is copied from the logic of PaymentMethodView component to return the payment method as string instead of component
// one of the usage of this method is for generate csv for subscriptions
export const getPaymentMethodDetailsText = ({
  invoiceGroupId,
  transactionAccount,
  paymentIssueStatusEnabled,
  isIGFallbackDisabled = false,
}: PaymentMethodProps) => {
  let currentInvoiceGroupDetails;
  if (!invoiceGroupId && !isIGFallbackDisabled) {
    currentInvoiceGroupDetails = transactionAccount?.availableInvoiceGroups?.nodes[0];
  } else {
    currentInvoiceGroupDetails = transactionAccount?.availableInvoiceGroups?.nodes?.find(
      (invoiceGroupObj) => invoiceGroupObj?.id === invoiceGroupId
    );
  }
  if (currentInvoiceGroupDetails?.defaultPaymentMethod) {
    if (currentInvoiceGroupDetails.defaultPaymentMethod?.type === PaymentMethodType.CARD) {
      const isPaymentIssue = currentInvoiceGroupDetails.defaultPaymentMethod?.paymentIssue === true;
      const creditCard = currentInvoiceGroupDetails.defaultPaymentMethod as CreditCard;
      return `**** **** **** ${creditCard?.card?.last4Numbers ?? ''}${
        isPaymentIssue && paymentIssueStatusEnabled ? ' - Payment error' : ''
      }`;
    } else if (currentInvoiceGroupDetails.defaultPaymentMethod?.type === PaymentMethodType.DEFERRED) {
      const paymentOnTerms = currentInvoiceGroupDetails.defaultPaymentMethod as PaymentOnTerms;
      return `Payment on terms: due in ${paymentOnTerms.terms?.invoiceDueDays} days`;
    }
  }
  return '-';
};
